import React from 'react';
import { getTranslatedText } from '@nile/components';
import { CHART_ICON } from '@nile/reports/src/modules/charts/utils/chart-transformation';
import { SVGIcon } from '@superops/super-icons';
import { TextStyle, Link } from '@superops/ui-design-system';
import { useIntl } from 'react-intl';

/**
 * Cells are specific to the components using the table.
 * This link cell is used to perform an action/redirection when clicked on it.
 */

function LinkCell(props) {
  const { cell } = props;
  const intl = useIntl();
  const meta = cell?.row?.original;
  const { actions } = cell.column;
  return cell.value ? (
    <div className="flex actr fw">
      <div className="flex actr jctr mr-10">
        <SVGIcon
          name={
            meta?.defaultChartType
              ? CHART_ICON[meta?.defaultChartType]
              : 'NumberChart'
          }
          size="lg"
        />
      </div>

      <div className="ellipsis">
        <Link onClick={actions.onClick.bind(this, meta)} removeUnderline>
          {cell.value}
        </Link>
      </div>
    </div>
  ) : (
    <TextStyle variation="subdued">
      {getTranslatedText(intl, 'app.noData.message')}
    </TextStyle>
  );
}

export default LinkCell;
